import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "student-selector-added-teacher-alert",
  "use": "student-selector-added-teacher-alert-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"student-selector-added-teacher-alert\"><path d=\"M10 0c5.525 0 10 4.475 10 10s-4.475 10-10 10S0 15.525 0 10 4.475 0 10 0zm1 5H9v6h2V5zm0 8H9v2h2v-2z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol